<template>
  <div class="add-property">
    <v-container>
      <h2 class="grey--text">Editar desarrollo</h2>
      <v-card class="mx-auto mt-4 pa-4" outlined>
        <v-card-title class="pa-0">Generales</v-card-title>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field label="Nombre del desarrollo" v-model="form.title" :rules="rules.title" required></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  :items="sectors"
                  item-text="title"
                  :rules="rules.sectors"
                  item-value="_id"
                  label="Sector"
                  v-model="form.sector"
                ></v-select>
              </v-col>
              <v-col cols="12" md="12">
                <v-textarea
                  label="Descripción"
                  v-model="form.description"
                  :rules="rules.description"
                  rows="3"
                  row-height="20"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-text-field label="Precio Minímo" prefix="$" v-model="form.minPrice"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="Precio Máximo" prefix="$" v-model="form.maxPrice"></v-text-field>
              </v-col>
            </v-row>
            
            <v-card-title class="pa-0">Logo</v-card-title>
            <v-row>           
              <v-col cols="3" md="3">
                <div v-if="!logoUrl" style="height:144px;width:100%;" class="grey lighten-3">
                  <input
                    id="logoFile"
                    class="mb-4 add-image-btn"
                    type="file"
                    block
                    @change="addLogoImage"
                  />
                  <label for="logoFile" class="grey lighten-3">
                    <span>
                      <v-icon>mdi-cloud-upload</v-icon>
                    </span>
                    <br />Agregar logo
                  </label>
                </div>
                <div v-else style="position:relative">
                  <v-btn
                    color="red"
                    class="v-btn--example"
                    dark
                    top
                    right
                    small
                    fab
                    style="position:absolute;z-index:3;top:-8px;right:20px;"
                    @click="removeLogoImage"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-img :src="logoUrl" max-height="144px"></v-img>
                </div>
                <!-- <p v-if="logoRule" class="error--text py-3">Ingresa la imagén del logo del desarrollo</p> -->
              </v-col>
              
            </v-row>

            <v-card-title class="pa-0 mt-3">Imágenes banner</v-card-title>
            <v-row>
              <v-col cols="3" md="3" v-for="(url, index) in urls" :key="url">
                <div style="position:relative;">
                  <v-btn
                    color="red"
                    class="v-btn--example"
                    dark
                    top
                    right
                    small
                    fab
                    style="position:absolute;z-index:3;top:-8px;right:20px;"
                    @click="removeImage(index)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-img :src="url" max-height="144px"></v-img>
                </div>
              </v-col>
              <v-col cols="3" md="3">
                <div style="height:144px;width:100%;" class="grey lighten-3">
                  <input
                    id="file"
                    class="mb-4 add-image-btn"
                    type="file"
                    block
                    @change="addImage"
                  />
                  <label for="file" class="grey lighten-3">
                    <span>
                      <v-icon>mdi-cloud-upload</v-icon>
                    </span>
                    <br />Agregar imágenes
                  </label>
                </div>
                <p v-if="imagesRule" class="error--text py-3">Ingresa por lo menos una imagén del desarrollo</p>
              </v-col>
            </v-row>

            <v-card-title class="pa-0 mt-3">Imágenes mobiles</v-card-title>
            <v-row>
              <v-col cols="3" md="3" v-for="(url, index) in mobileUrls" :key="url">
                <div style="position:relative;">
                  <v-btn
                    color="red"
                    class="v-btn--example"
                    dark
                    top
                    right
                    small
                    fab
                    style="position:absolute;z-index:3;top:-8px;right:20px;"
                    @click="removeMobileImage(index)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-img :src="url" max-height="144px"></v-img>
                </div>
              </v-col>
              <v-col cols="3" md="3">
                <div style="height:144px;width:100%;" class="grey lighten-3">
                  <input
                    id="MobileFile"
                    class="mb-4 add-image-btn"
                    type="file"
                    block
                    @change="addMobileImage"
                  />
                  <label for="MobileFile" class="grey lighten-3">
                    <span>
                      <v-icon>mdi-cloud-upload</v-icon>
                    </span>
                    <br />Agregar mobiles Imágenes del banner
                  </label>
                </div>
              </v-col>
            </v-row>
            
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field label="URL de video" v-model="form.videoUrl" :rules="rules.videoUrl"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="URL" v-model="form.url" :rules="rules.url"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field label="Latitud" v-model="form.lat" :rules="rules.lat"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="Longitud" v-model="form.lng" :rules="rules.lng"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>
      
      <v-spacer></v-spacer>
      <v-btn
        class="my-4"
        color="primary"
        :loading="loading"
        depressed
        @click="validate"
      >Guardar</v-btn>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import constants from "../constants";
export default {
  data() {
    return {
      api: constants.API,
      id: this.$route.params.id,
      selectedFile: null,
      selectedFiles: [],
      urls: [],
      mobileUrls: [],
      selectedFileLogo: null,
      logoUrl: null,
      form: {
        title: null,
        description: null,
        videoUrl: null,
        url: null,
        sector: null,
        lat: null,
        lng: null,
        minPrice : 0,
        maxPrice : 0
      },
      loading: false,
      valid: true,
      imagesValid: false,
      logo: null,
      logoRule: false,
      imagesRule: false,
      sectors: [],
      rules: {
        title: [v => !!v || "Nombre del desarrollo requerido"],
        description: [v => !!v || "Descripción requerida"],
        videoUrl: [v => !!v || "URL del desarrollo requerido"],
        url: [v => !!v || "URL requerida"],
        sectors: [v => !!v || "Sector requerido"],
        lat: [v => !!v || "Latitud requerida"],
        lng: [v => !!v || "Longitud requerida"]
      },
      initialImages: [],
      deleteImages: [],
      images: [],
      mobileImages: []
    };
  },
  mounted() {
    this.getDevelopment();
    this.getSectors();
  },
  methods: {
    getSectors() {
      this.$http
        .get(`sector/`)
        .then((res) => {
          this.sectors = res.data.data
        })
        .catch((error) => console.log(error));
    },
    getDevelopment() {
      this.$http
        .get(`development/${this.id}`)
        .then((res) => {
          this.form.title = res.data.data.title;
          this.form.description = res.data.data.description;
          this.form.videoUrl = res.data.data.videoUrl;
          this.form.url = res.data.data.slug;
          this.form.sector = res.data.data.sector;
          this.form.lat = res.data.data.location.coordinates[0];
          this.form.lng = res.data.data.location.coordinates[1];
          this.logo = res.data.data.logoImage;

          this.form.minPrice = res.data.data.minPrice != '' && res.data.data.minPrice != null ? res.data.data.minPrice : 0;
          this.form.maxPrice = res.data.data.maxPrice != '' && res.data.data.maxPrice != null ? res.data.data.maxPrice : 0;
          
          this.images = res.data.data.images;
          this.mobileImages = res.data.data.mobileImages;

          for (const image of this.images) {
            let url = `${this.api}images/${image}`;
            this.urls.push(url);
          }

          for (const image of this.mobileImages) {
            let url = `${this.api}images/${image}`;
            this.mobileUrls.push(url);
          }
          
          if (this.logo) {
            // Change local or prod
            this.logoUrl = `${this.api}images/${this.logo}`;
          }
        })
        .catch((error) => console.log(error));
    },
    editDevelopment() {
      this.loading = true

      let location = {
        "type": "Point",
        "coordinates": [this.form.lat, this.form.lng]
      }

      const formData = {
        title: this.form.title,
        description: this.form.description,
        videoUrl: this.form.videoUrl,
        slug: this.form.url,
        sector: this.form.sector,
        location: location,
        minPrice : this.form.minPrice,
        maxPrice : this.form.maxPrice
      }

      this.$http
        .put(`development/${this.id}`, formData)
        .then((res) => {
          this.loading = false;
          this.$store.commit("SNACKBAR", {
            text: "Desarrollo editado con éxito",
            type: "success",
            isShow: true
          });
          this.$router.replace("/developments");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async validate() {
      await this.$refs.form.validate();

      if (!this.logoUrl && !this.selectedFileLogo) {
        this.imagesValid = false;
        this.logoRule = true;
        this.imagesRule = false;
      } else if (this.selectedFiles.length == 0 && this.urls.length == 0) {
        this.imagesValid = false;
        this.logoRule = false;
        this.imagesRule = true;
      } else {
        this.imagesValid = true;
        this.logoRule = false;
        this.imagesRule = false;
      }
      
      if (!this.valid || !this.imagesValid) {
        return;
      } else {
        this.editDevelopment();
      }
    },
    addImage(e) {
      const formData = new FormData();

      this.selectedFile = e.target.files[0];

      formData.append("image", this.selectedFile)

      this.$http
        .put(`development/addImage/${this.id}`,  formData)
        .then((res) => {
          // this.loading = false;
          this.$store.commit("SNACKBAR", {
            text: "Imagén agregada con éxito",
            type: "success",
            isShow: true
          });

          this.urls = [];
          this.mobileUrls = [];

          this.getDevelopment();
          this.getSectors();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    removeImage(index) {
      this.$http
        .put(`development/removeImage/${this.id}`, null, { params: { image: this.images[index] }})
        .then((res) => {
          // this.loading = false;
          this.$store.commit("SNACKBAR", {
            text: "Imagén eliminada con éxito",
            type: "success",
            isShow: true
          });

          this.urls = [];
          this.mobileUrls = [];

          this.getDevelopment();
          this.getSectors();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addMobileImage(e) {
      const formData = new FormData();

      this.selectedFile = e.target.files[0];

      formData.append("image", this.selectedFile)

      this.$http
        .put(`development/addMobileImage/${this.id}`, formData)
        .then((res) => {
          // this.loading = false;
          this.$store.commit("SNACKBAR", {
            text: "Imagén agregada con éxito",
            type: "success",
            isShow: true
          });

          this.urls = [];
          this.mobileUrls = [];

          this.getDevelopment();
          this.getSectors();
        })
        .catch((error) => {
          console.log(error);
        });
    }, 
    removeMobileImage(index) {
      this.$http
        .put(`development/removeMobileImage/${this.id}`, null, { params: { image: this.mobileImages[index] }})
        .then((res) => {
          // this.loading = false;
          this.$store.commit("SNACKBAR", {
            text: "Imagén eliminada con éxito",
            type: "success",
            isShow: true
          });

          this.urls = [];
          this.mobileUrls = [];

          this.getDevelopment();
          this.getSectors();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addLogoImage(e) {
      const formData = new FormData();

      this.selectedFile = e.target.files[0];

      formData.append("image", this.selectedFile)

      this.$http
        .put(`development/addLogo/${this.id}`, formData)
        .then((res) => {

          this.$store.commit("SNACKBAR", {
            text: "Logo agregado con éxito",
            type: "success",
            isShow: true
          });

          this.urls = [];
          this.mobileUrls = [];

          this.getDevelopment();
          this.getSectors();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    removeLogoImage(e) {
      this.$http
        .put(`development/removeLogo/${this.id}`, null, { params: { image: this.logo }})
        .then((res) => {
          this.$store.commit("SNACKBAR", {
            text: "Logo eliminado con éxito",
            type: "success",
            isShow: true
          });

          this.urls = [];
          this.mobileUrls = [];
          this.logoUrl = null;

          this.getDevelopment();
          this.getSectors();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
};
</script>

<style scoped>
.add-image-btn {
  display: none;
}

label {
  padding: 40px;
  /* background: green; */
  height: 100%;
  width: 100%;
  border-radius: 4px;
  /* color: #fff; */
  text-align: center;
  font-weight: 500;
  font-size: 1.1rem;
  display: block;
  cursor: pointer;
}

.v-btn--example {
  bottom: 0;
  position: absolute;
  margin: 0px -24px 0px 0px;
}
</style>
